import { BoxProps, TextProps } from '@jfs/ui-new'

const defaultCardBox = {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  paddingHorizontal: 24,
  paddingVertical: 24,
  backgroundColor: 'WHITE',
  borderColor: 'GREY_1_SEPARATOR',
  borderWidth: 'SMALL',
  borderRadius: 8,
  shadowColor: 'GRAY_SHADOW',
  shadowOffset: {
    width: 0,
    height: 10,
  },
  shadowOpacity: 1,
  shadowRadius: 16,
} as BoxProps

export const styles = {
  alertOutercontainer: {
    ...defaultCardBox,
    minHeight: 144,
  } as BoxProps,
  alertRejectOutercontainer: {
    ...defaultCardBox,
    minHeight: 470,
    paddingHorizontal: 0,
    paddingVertical: 0,
  } as BoxProps,
  approveTitlesBox: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
  } as BoxProps,
  titlesBox: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingHorizontal: 24,
    paddingTop: 16,
  } as BoxProps,
  buttonsBox: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginTop: 16,
  } as BoxProps,
  title: {
    fontSize: 14,
    type: 'body1',
    color: 'BLACK',
    weight: 'dense',
    fontFamily: 'jioType-medium',
  } as TextProps,
  subTitle: {
    fontWeight: 'FONT_WEIGHT_BOLD',
    fontSize: 'FONT_SIZE_MEDIUM',
    color: 'BLACK',
    type: 'headline',
    fontFamily: 'jioType-medium',
  } as TextProps,
  cancelBtn: {
    minWidth: 128,
    height: 40,
    backgroundColor: 'WHITE',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
    borderWidth: 1,
    borderColor: 'PRIMARY',
    borderRadius: 8,
    underlayColor: 'PRIMARY',
  } as BoxProps,
  approveRejectBtn: {
    minWidth: 128,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'PRIMARY',
    borderRadius: 8,
    marginLeft: 8,
    underlayColor: 'PRIMARY',
  } as BoxProps,
  closeIconBox: {
    justifyContent: 'flex-end',
    marginRight: 16,
    marginTop: 16,
    width: 24,
    height: 24,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  approvecloseIconBox: {
    justifyContent: 'flex-end',
    marginLeft: 16,
    width: 24,
    height: 24,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  approvetopBox: {
    flexDirection: 'row',
  } as BoxProps,
  topBox: {
    marginLeft: 40,
    marginRight: 40,
    width: '100%',
    flexDirection: 'row',
  } as BoxProps,
  dropdown: {
    padding: 16,
  } as BoxProps,
  textInputBox: {} as BoxProps,
  formBox: {
    flex: 1,
    paddingHorizontal: 8,
  } as BoxProps,
  radioBgView: {
    width: '100%',
    // flex: 1,
    marginVertical: 8,
  } as BoxProps,
}
